export default __webpack_public_path__ + "static/media/bet.b8336211.mp3";